export const AGENDA_DATETIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";

export const FULL_DAY_THRESHOLD_IN_MINUTES = 1439;
export const FULL_DAY_IN_MINUTES = 1440;

export enum EVENT_TYPES {
  partial = 'partial',
  recurring = 'recurring',
  recurringHostingHours = 'recurringHostingHours',
  fullday = 'fullday',
  booked = 'booked',
  experience = 'experience',
  hostAway = 'hostAway',
}

export const RECURRENCE_TYPES = {
  daily: 'DAILY',
  weekly: 'WEEKLY',
  monthly: 'MONTHLY',
  yearly: 'YEARLY',
};
